<!-- Filters -->
<div
  fxLayout="row wrap"
  fxLayoutAlign="space-between center"
  class="top-panel-control content-body"
>
  <!-- variety filter -->
  <mat-form-field fxFlex="22" appearance="outline">
    <mat-label>Variedad</mat-label>
    <input
      type="text"
      placeholder="Seleccione uno..."
      matInput
      [formControl]="variety_control"
      [matAutocomplete]="auto1"
    />
    <button
      mat-button
      matSuffix
      aria-label="Arrow"
      *ngIf="!variety_control.value"
      mat-icon-button
      class="mat-select-arrow-wrapper"
    >
      <div class="mat-select-arrow"></div>
    </button>
    <button
      mat-button
      *ngIf="variety_control.value"
      matSuffix
      mat-icon-button
      (click)="fnParamsDataChange({ p_variety_name: null }, 'p_variety_name')"
    >
      <mat-icon>close</mat-icon>
    </button>
    <mat-autocomplete
      autoActiveFirstOption
      #auto1="matAutocomplete"
      panelWidth="24em"
      (optionSelected)="
        fnParamsDataChange(
          { p_variety_name: variety_control.value },
          'p_variety_name'
        )
      "
    >
      <mat-option
        *ngFor="let option of filteredOptionsVariety | async"
        [value]="option"
      >
        {{ option }}
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>
  <!-- farmer filter -->
  <mat-form-field fxFlex="22" appearance="outline">
    <mat-label>Hogares</mat-label>
    <input
      type="text"
      placeholder="Seleccione uno..."
      matInput
      [formControl]="farmer_control"
      [matAutocomplete]="auto3"
    />
    <button
      mat-button
      matSuffix
      *ngIf="!farmer_control.value"
      mat-icon-button
      class="mat-select-arrow-wrapper"
    >
      <div class="mat-select-arrow"></div>
    </button>
    <button
      mat-button
      *ngIf="farmer_control.value"
      matSuffix
      mat-icon-button
      (click)="fnParamsDataChange({ p_farmer_name: null }, 'p_farmer_name')"
    >
      <mat-icon>close</mat-icon>
    </button>
    <mat-autocomplete
      autoActiveFirstOption
      #auto3="matAutocomplete"
      panelWidth="24em"
      (optionSelected)="
        fnParamsDataChange(
          { p_farmer_name: farmer_control.value },
          'p_farmer_name'
        )
      "
    >
      <mat-option
        *ngFor="let option of filteredOptionsFarmer | async"
        [value]="option"
      >
        {{ option }}
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>
  <!-- Advance filter -->
  <button
    fxFlex.xs="100"
    #bt
    mat-stroked-button
    (click)="fnOpenDialog(bt, 900)"
    matBadge="{{ badgeFilter }}"
    matBadgeColor="primary"
    style="background-color: #c4a1c0; color: #fff"
  >
    <mat-icon>tune</mat-icon> Filtros
  </button>
</div>
<!-- Banda informativa -->
<div fxLayout="row wrap" style="background-color: #c4a1c0">
  <div fxFlex="33" fxFlex.md="33" fxFlex.sm="50"></div>
  <!-- OBSERVACIONES -->
  <div
    fxFlex="12"
    fxFlex.md="12"
    fxFlex.sm="50"
    fxFlex.xs="100"
    style="padding: 0.5em; background-color: #ac40b3; color: #fff"
  >
    <mat-icon>visibility</mat-icon>
    <span style="font-size: 2em; font-weight: 700">
      {{ observation_count }}
    </span>
    <span>OBSERVACIONES</span>
  </div>
  <!-- VARIEDADES -->
  <div
    fxFlex="12"
    fxFlex.md="12"
    fxFlex.sm="50"
    fxFlex.xs="100"
    style="
      border-right: solid 2px #ffe39f;
      padding: 0.5em;
      color: #fff;
      cursor: pointer;
    "
    (click)="fnGoToCatalogView()"
  >
    <mat-icon>image</mat-icon>
    <span style="font-size: 2em; font-weight: 700"> {{ variety_count }} </span
    ><br />
    <span>VARIEDADES</span>
  </div>
  <!-- OBSERVADORES -->
  <div
    fxFlex="12"
    fxFlex.md="12"
    fxFlex.sm="50"
    fxFlex.xs="100"
    style="border-right: solid 2px #ffe39f; padding: 0.5em; color: #fff"
  >
    <mat-icon>person</mat-icon>
    <span style="font-size: 2em; font-weight: 700"> {{ observer_count }} </span
    ><br />
    <span>OBSERVADORES</span>
  </div>
  <!-- HOGARES -->
  <div
    fxFlex="12"
    fxFlex.md="12"
    fxFlex.sm="50"
    fxFlex.xs="100"
    style="border-right: solid 2px #ffe39f; padding: 0.5em; color: #fff"
  >
    <mat-icon>person</mat-icon>
    <span style="font-size: 2em; font-weight: 700"> {{ farmer_count }} </span
    ><br />
    <span>HOGARES</span>
  </div>
</div>
<!-- Buscador avanzado y paginador -->
<div
  fxLayout="row wrap"
  fxLayoutAlign="space-between center"
  class="content-body"
>
  <div fxFlex="35" fxFlex.sm="50%" fxFlex.xs="100%">
    <mat-button-toggle-group [(ngModel)]="viewType">
      <mat-button-toggle value="catalogo"
        ><mat-icon>view_comfy</mat-icon> Cuadricula</mat-button-toggle
      >
      <mat-button-toggle value="lista"
        ><mat-icon>view_list</mat-icon> Lista</mat-button-toggle
      >
      <mat-button-toggle value="mapa"
        ><mat-icon>place</mat-icon> Mapa</mat-button-toggle
      >
    </mat-button-toggle-group>
  </div>

  <div fxFlex="20" fxFlex.sm="50%" fxFlex.xs="100%">
    <button
      mat-button
      color="warn"
      *ngIf="badgeFilter"
      (click)="fnClearFilters()"
    >
      <mat-icon>restart_alt</mat-icon> Limpiar filtros
    </button>
  </div>

  <div
    *ngIf="viewType == 'mapa'"
    fxFlex="45"
    fxFlex.sm="50%"
    fxFlex.xs="100%"
    class="right-middle"
  >
    <button mat-button color="warn" (click)="fnGetAllCoordinates()">
      <mat-icon>visibility</mat-icon>
      Ver todos
    </button>
  </div>

  <div *ngIf="viewType != 'mapa'" fxFlex="45" fxFlex.sm="100%" fxFlex.xs="100%">
    <mat-paginator
      [pageIndex]="page_control"
      [pageSize]="page_size_control"
      [length]="_length"
      [showFirstLastButtons]="_showFirstLastButtons"
      [pageSizeOptions]="_pageSizeOptions"
      (page)="handlePageEvent($event)"
    >
    </mat-paginator>
  </div>
</div>
<!-- vista catalogo -->
<div class="content-body" *ngIf="viewType == 'catalogo'">
  <div fxLayout="row wrap" fxLayoutGap="32px grid">
    <div
      fxFlex="25%"
      fxFlex.sm="50%"
      fxFlex.xs="100%"
      *ngFor="let cardContent of cardContentList"
    >
      <app-template-card
        [cardContent]="cardContent"
        [route]="'observacion'"
      ></app-template-card>
    </div>
  </div>
</div>
<!-- vista lista -->
<div class="content-body" *ngIf="viewType == 'lista'">
  <div
    fxLayout="column"
    fxLayoutAlign="space-between stretch"
    *ngIf="cardContentList.length"
  >
    <div
      fxLayout="row"
      fxLayoutAlign="space-between stretch"
      style="
        margin-bottom: 0.5em;
        border: solid 1px #ddd;
        padding: 0.5em;
        background-color: #fff;
        color: #8b2f00;
        font-weight: 500;
      "
    >
      <div fxFlex="15" style="display: flex; align-items: center">
        <span>Multimedia</span>
      </div>
      <div fxFlex="30" style="padding: 1em; display: flex; align-items: center">
        <span>Nombre</span>
      </div>
      <div fxFlex="15" style="padding: 1em; display: flex; align-items: center">
        <span>Usuario</span>
      </div>
      <div fxFlex="20" style="padding: 1em; display: flex; align-items: center">
        <span>Observado el</span>
      </div>
      <div fxFlex="20" style="padding: 1em; display: flex; align-items: center">
        <span>Lugar</span>
      </div>
    </div>

    <div *ngFor="let cardContent of cardContentList">
      <app-template-row-view-obs
        [cardContent]="cardContent"
        [route]="'observacion'"
      ></app-template-row-view-obs>
    </div>
  </div>
</div>
<!-- vista mapa -->
<div class="content-body" *ngIf="viewType == 'mapa'">
  <app-template-map
    *ngIf="gpsCoordinateList.length > 0"
    [coordinate_list]="gpsCoordinateList"
    [height_value]="'650px'"
  >
  </app-template-map>
</div>
<!-- paginador -->
<div *ngIf="viewType != 'mapa'">
  <mat-paginator
    [pageIndex]="page_control"
    [pageSize]="page_size_control"
    [length]="_length"
    [showFirstLastButtons]="_showFirstLastButtons"
    [pageSizeOptions]="_pageSizeOptions"
    (page)="handlePageEvent($event)"
    class="content-body"
  >
  </mat-paginator>
</div>
